import { render, staticRenderFns } from "./BotChange.vue?vue&type=template&id=3782c2f8&"
import script from "./BotChange.vue?vue&type=script&lang=js&"
export * from "./BotChange.vue?vue&type=script&lang=js&"
import style0 from "./BotChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports